import {applyMiddleware, createStore, compose} from "redux";
import {createLogger} from 'redux-logger';
import thunk from 'redux-thunk';
import reduxFreeze from 'redux-freeze';
import throttle from "redux-throttle";
import { routerMiddleware } from 'connected-react-router';

import _compact from "lodash/compact";
import rootReducer from './reducers/rootReducer';
import history from './history';

const defaultWait = 300;
const defaultThrottleOption = {
    leading: true,
    trailing: true
};

const logger = createLogger();
const middlewares = _compact([routerMiddleware(history), throttle(defaultWait, defaultThrottleOption), thunk, reduxFreeze]);
const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore);
const store = createStoreWithMiddleware(rootReducer(history), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export default store;
